const timeline = [
  {
    time: "07h30 – 08h30",
    title: "Credenciamento",
    desc: "Retire seu kit e confirme sua presença. Prepare-se para uma manhã incrível!",
    icon: "ri-shield-check-line",
    color: "bg-[#CDE3BB]",
    accent: "#BCD033",
    textAccent: "text-[#008C51]",
  },
  {
    time: "08h00 – 08h30",
    title: "Abertura",
    desc: "Cerimônia de boas-vindas e apresentação Instituto Unimed BH.",
    icon: "ri-megaphone-line",
    color: "bg-[#F0CDCD]/60",
    accent: "#F0CDCD",
    textAccent: "text-[#008C51]",
  },
  {
    time: "08h30 – 10h00",
    title: "Atividades Mente",
    desc: "Meditação · Yoga · Tai Chi Chuan · LPF\u00A0·\u00A0Mobilidade Articular",
    icon: "ri-mental-health-line",
    color: "bg-[#CDE3BB]",
    accent: "#BCD033",
    textAccent: "text-[#008C51]",
    highlight: true,
  },
  {
    time: "10h20 – 11h40",
    title: "Atividades Corpo",
    desc: "Mix de Danças · Funcional · Beach Tennis · Padel",
    icon: "ri-run-line",
    color: "bg-[#A4D8DE]/50",
    accent: "#A4D8DE",
    textAccent: "text-[#008C51]",
    highlight: true,
  },
  {
    time: "11h40 – 12h20",
    title: "Encerramento",
    desc: "Momento de celebração, conexões e despedida.",
    icon: "ri-heart-line",
    color: "bg-[#F0CDCD]/60",
    accent: "#F0CDCD",
    textAccent: "text-[#008C51]",
  },
];

export default function Schedule() {
  return (
    <section id="cronograma" className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="text-[#BCD033] text-sm font-bold tracking-widest uppercase">12 de Abril de 2026</span>
          <h2 className="text-4xl font-extrabold text-[#008C51] mt-2">Programação do Dia</h2>
          <p className="text-gray-500 mt-3 max-w-lg mx-auto text-sm">
            Uma manhã completa de movimento, presença e bem-estar. Confira os horários e se prepare!
          </p>
        </div>

        <div className="relative">
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-[#BCD033] via-[#F0CDCD] to-[#A4D8DE] -translate-x-1/2" />

          <div className="flex flex-col gap-6">
            {timeline.map((item, i) => (
              <div
                key={i}
                className={`flex items-center gap-6 ${i % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"}`}
              >
                <div className={`flex-1 ${i % 2 === 0 ? "md:text-right" : "md:text-left"}`}>
                  <div
                    className={`inline-block ${item.color} rounded-2xl p-5 max-w-sm w-full transition-transform hover:-translate-y-1 duration-200`}
                  >
                    <div className={`flex items-center gap-3 ${i % 2 === 0 ? "md:flex-row-reverse" : ""}`}>
                      <div
                        className="w-10 h-10 flex items-center justify-center rounded-xl"
                        style={{ backgroundColor: item.accent + "55" }}
                      >
                        <i className={`${item.icon} text-xl`} style={{ color: "#008C51" }} />
                      </div>
                      <div className={i % 2 === 0 ? "md:text-right" : ""}>
                        <p className="text-xs font-bold text-gray-400 tracking-wider">{item.time}</p>
                        <h3 className={`font-extrabold text-lg ${item.textAccent}`}>{item.title}</h3>
                      </div>
                    </div>
                    <p className={`text-gray-600 text-sm mt-2 ${i % 2 === 0 ? "md:text-right" : ""}`}>
                      {item.desc}
                    </p>
                    {item.highlight && (
                      <div className={`mt-2 flex gap-2 ${i % 2 === 0 ? "md:justify-end" : ""} flex-wrap`}>
                        <span
                          className="text-xs font-semibold px-2 py-0.5 rounded-full text-[#008C51]"
                          style={{ backgroundColor: item.accent + "44" }}
                        >
                          Várias modalidades
                        </span>
                      </div>
                    )}
                  </div>
                </div>

                <div
                  className="hidden md:flex w-10 h-10 items-center justify-center rounded-full border-4 border-white flex-shrink-0 z-10"
                  style={{ backgroundColor: item.accent }}
                >
                  <i className={`${item.icon} text-white text-sm`} />
                </div>

                <div className="flex-1 hidden md:block" />
              </div>
            ))}
          </div>
        </div>


      </div>

      <div className="mt-14">
        <img
          src="https://storage.readdy-site.link/project_files/ca8f3ce7-75b3-4a89-a83a-a57d16fa0d98/5244b677-089b-44cb-aa57-641e54e18111_CRONO-1.png?v=88895d11b2b0ab5c7ccf7c87d95e9596"
          alt="Cronograma detalhado do evento"
          className="w-full h-auto block"
        />
      </div>
    </section>
  );
}
